<template>
<v-app light>
    <!-- <v-toolbar color="white">
      <v-toolbar-title v-text="title"></v-toolbar-title>
    </v-toolbar> -->
    <v-content>
      <section>
        <v-parallax src="././assets/hero.jpg" height="400">
          <v-layout
            column
            align-center
            justify-center
            class="white--text"
          >
            <img src="././assets/vuetify.png" alt="Vuetify.js" height="200">
            <h1 class="white--text mb-2 display-1 text-center">Welcome to MagicSpark.eu</h1>
            <!-- <div class="subheading mb-4 text-center">Powered by Vuetify</div> -->
            <!-- <v-btn
              class="mt-12"
              color="blue lighten-2"
              dark
              large
              href="/pre-made-themes"
            >
              Get Started
            </v-btn> -->
          </v-layout>
        </v-parallax>
      </section>

      <section>
        <v-layout
          column
          wrap
          class="my-12"
          align-center
        >
          <v-flex xs12 sm4 class="my-4">
            <div class="text-center">
              <h2 class="headline">Our rules:</h2>
              <p class="subheading">
              We believe that our mission is not to just buy or sell, but to help people in completing their decks and/or collections. So that we have some simple rules.
              </p>
            </div>
          </v-flex>
          <v-flex xs12>
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex xs12 md4 offset-md-2>
                  <v-card flat class="transparent">
                    <v-card-text class="text-center">
                      <v-icon x-large class="text--lighten-2" color="pink darken-3">mdi-basket-unfill</v-icon>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center" >
                      <div class="headline text-center">We don't sell</div>
                    </v-card-title>
                    <v-card-text>
                      We help players and collectors to search for cards they need. We know the importance of finishing your deck or collection very well.
                      So we've never had a concept of a minimum order value. Especially when we talk about foil cats, angels or vampires(Sorin &lt;3)
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card flat class="transparent">
                    <v-card-text class="text-center">
                      <v-icon x-large class="text--lighten-2" color="pink darken-3">mdi-basket-fill</v-icon>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-center">We don't buy</div>
                    </v-card-title>
                    <v-card-text>
                      We evaluate your collection and offer a decent price depending on this evaluation.
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </section>

      <section>
        <v-parallax src="././assets/section.jpg" height="280">
          <!-- <v-layout column align-center justify-center>
            <div class="headline white--text mb-4 text-center">Web development has never been easier</div>
            <em>Kick-start your application today</em>
            <v-btn
              class="mt-12"
              color="blue lighten-2"
              dark
              large
              href="/pre-made-themes"
            >
              Get Started
            </v-btn>
          </v-layout> -->
        </v-parallax>
      </section>

      <section>
        <v-container grid-list-xl>
          <v-layout row wrap justify-center class="my-12">
            <v-flex xs12 sm4>
              <v-card flat class="transparent">
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline">Hello, everyone!</div>
                </v-card-title>
                <v-card-text>
                  <p class="subheading">My name is <strong>Nikita</strong>, I am an MTG player and a collector currently living in the <strong>Czech&nbsp;Republic</strong>.</p>
                  <p class="subheading">What is MagicSpark? We're a big friendly team based in Moscow with an <strong>amazing&nbsp;pool</strong> of MTG cards.</p>
                  <p class="subheading">As being a part of a MagicSpark I can help you handle your MTG collection in any way. While I am mostly oriented to sell and find <strong>russian cards</strong>, it doesn't nearly cover all the possible services I can provide.</p>
                  <p>Just wanna buy something that I currently have? Great, you're welcome! Can't find a particular card? - I can find it for ya! Have some cards to sell or trade? Sure, why not. Feel free to contact me and ask anything - We can always have a deal!</p>
                  <p>Our main goal is to make YOU happy - so please <strong>go on</strong>! </p>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm4 offset-sm1>
              <v-card flat class="transparent">
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline">Contact me</div>
                </v-card-title>
                <!-- <v-card-text>
                  write to me at any time, I will try to respond promptly
                </v-card-text> -->
                <v-list class="transparent">
                  <v-list-item>
                    <v-list-item-action>
                      <v-icon class="blue--text text--lighten-2">mdi-telegram</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title><a href="tg://resolve?domain=@TexasJaguar">@TexasJaguar</a></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-action>
                      <v-icon class="blue--text text--lighten-2">mdi-email</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title><a href="mailto:talkto@magicspark.eu">talkto@magicspark.eu</a></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </section>
      <v-footer color="blue darken-2">
        <v-layout row wrap align-center>
          <v-flex xs12>
            <div class="white--text ml-4">
              Made with
              <v-icon class="red--text">mdi-heart</v-icon>
              by <a class="white--text" href="tg://resolve?domain=@NikolaPeshkov" target="_blank">@NikolaPeshkov</a>
              and <a class="white--text" href="tg://resolve?domain=@TexasJaguar">@TexasJaguar</a>
              © {{ new Date().getFullYear() }} - MagicSpark.eu
            </div>
          </v-flex>
        </v-layout>
      </v-footer>
      <v-footer>
        <v-fles xs12>
          <div class="ml-4">This website is not produced, endorsed, supported, or affiliated with Wizards of the Coast.</div>
        </v-fles>
      </v-footer>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({ title: 'MagicSpark.eu' }),
};
</script>
